<template>
  <div>
    <form id="delete" @submit.prevent="showModal = true">
        <input type="submit" class="submit" v-bind:value="$t('admin.adminPolicyDelete.button.delete')">
    </form>
    <Modal class="alert" v-if="showModal" v-bind:modalTitle="$t('admin.adminPolicyDelete.modal.header', {name: policy[0].policyName})" @close="showModal = false">
      <p class="modal-text" v-html="$t('admin.adminPolicyDelete.modal.text')"></p>
      <a v-on:click.prevent="deletePolicy" class="button" href="#">{{ $t("admin.adminPolicyDelete.modal.button") }}</a>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue'

import { adminService } from '@/services/admin.service'

export default {
  props: ['policy'],
  name: 'AdminPolicyDelete',
  components: {
    Modal
  },
  data: function () {
    return {
      showModal: false
    }
  },
  methods: {
    deletePolicy: function () {
      adminService.policyDelete(this.policy[0].policyId).then(() => {
        console.log('delete policy: ' + this.policy[0].policyName)
        this.showModal = false
        this.$router.push('/admin/policyList/')
      }).catch((err) => {
        console.error('Unable to delete policy: ', err)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.modal-text {
  font-weight: bold;
}
</style>
